import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';

const AuthOnlyRoute = ({ children }) => {
  const { isAuthenticated, isInVerificationProcess } = useSelector((state) => state.auth);
  const location = useLocation();

  // Check if user is in verification process (either from Redux state or localStorage)
  const tempUser = localStorage.getItem("dbx_aff_temp_user");
  const verificationEmail = localStorage.getItem("dbx_aff_verification_email");
  const isInVerification = isInVerificationProcess || (tempUser && verificationEmail);

  // If not authenticated and not in verification process, redirect to login
  if (!isAuthenticated && !isInVerification) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // If authenticated or in verification process, render children (verification not required)
  return children;
};

export default AuthOnlyRoute;
